<div
  class="video"
  [class.has--popup]="!inline()"
  (mouseenter)="previewVideo(true)"
  (mouseleave)="previewVideo(false)"
  (mouseup)="playVideo()"
  >
  <div class="video__overlay" [class.is--hidden]="!showPoster">
    <img [src]="youtubePoster$()" [alt]="videoAltText$()" loading="lazy" />

    <button class="button button-icon button--{{ color() }} button--lg" aria-label="Video afspelen" [disabled]="previewOnly()">
      @if (state !== 1 && state !== 3) {
        <fstr-icon anchor="icon-play"></fstr-icon>
      }
      @if (state === 3) {
        <fstr-icon anchor="icon-loader" class="anim--spinning"></fstr-icon>
      }
    </button>
  </div>

  @if (!previewOnly() && inline()) {
    <fstr-youtube-player
      (ready)="onPlayerReady($event)"
      (change)="onPlayerChange($event)"
      #youtube
      [src]="url()"
      [config]="youtubeConfig()"
      [cookies]="cookiePreferences()?.marketing || false"
    ></fstr-youtube-player>
  }
</div>
